export const getEansFormatados = (item) => {
	if (!item) return "";
	if (item.eans && item.eans.length > 0) {
		return item.eans.join(" ou ");
	}
	return item.codigoEAN;
};
